<template> <!-- メイン画面 -->
  <div class="c-app">
    <template v-if="sidebar_type == 'admin'">
      <TheAdminSidebar/>
    </template>
    <template v-else-if="sidebar_type == 'clerk'">
      <TheClerkSidebar/>
    </template>
    <template v-else>
      <TheSidebar/>
    </template>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheAdminSidebar from './TheAdminSidebar'
import TheClerkSidebar from './TheClerkSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import axios from 'axios'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAdminSidebar,
    TheClerkSidebar
  },
  data () {
    return {
      sidebar_type: ""
    }
  },

  created: function () {
axios
      .get((process.env.VUE_APP_API_ORIGIN) + '/authority')
      .then(response => {
        if(response.status === 200) {
          this.sidebar_type = response.data
        }
      })
    }

}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
